/*
  Footer newsletter → interest preferences popup.

  Intercepts the footer signup, asks which emails the subscriber wants, sends
  those choices straight to Mailchimp (interest group 52112 on the Core
  consumer audience) and then submits the Shopify form exactly as before, so
  the customer record and the Mailchimp app sync are unchanged.

  Mailchimp's public endpoint rejects addresses that are already on the list,
  so existing subscribers keep their current interests.
*/
(function() {
  var TIMEOUT_MS = 5000;

  function init() {
    var form = document.getElementById('newsletter-footer');
    var modalEl = document.querySelector('[data-footer-newsletter-prefs]');
    if (!form || !modalEl || !window.theme || !theme.Modals) return;

    // Move to <body> so the fixed overlay isn't clipped by the footer layout.
    document.body.appendChild(modalEl);
    var modal = new theme.Modals(modalEl.id, 'footer-newsletter-prefs');

    var emailInput = form.querySelector('input[type="email"]');
    var submitBtn = modalEl.querySelector('[data-prefs-submit]');
    var released = false;

    function submitShopify() {
      if (released) return;
      released = true;
      // Sent as popup_name newsletter_footer in GA4, for the marketing dashboard.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead', popup: 'newsletter_footer' });
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    function sendToMailchimp(done) {
      var params = new URLSearchParams();
      params.append('u', modalEl.dataset.mcU);
      params.append('id', modalEl.dataset.mcId);
      params.append('EMAIL', emailInput.value.trim());
      params.append(modalEl.dataset.mcHoneypot, '');
      modalEl.querySelectorAll('input[name^="group["]:checked').forEach(function(box) {
        params.append(box.name, box.value);
      });

      var callbackName = 'footerNewsletterPrefs' + Date.now();
      var script = document.createElement('script');
      var finished = false;

      function finish() {
        if (finished) return;
        finished = true;
        delete window[callbackName];
        script.remove();
        done();
      }

      window[callbackName] = finish;
      params.append('c', callbackName);
      script.src = modalEl.dataset.mcAction + '?' + params.toString();
      script.onerror = finish;
      document.body.appendChild(script);
      setTimeout(finish, TIMEOUT_MS);
    }

    // Shopify's spam check (storefront-forms-hcaptcha) adds its own submit
    // listener to the form and submits it once the check passes. Catch the
    // event first, in the capture phase, so the popup gets a chance; the
    // spam check then runs on the real submit from submitShopify().
    document.addEventListener('submit', function(evt) {
      if (evt.target !== form || released) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      modal.open();
    }, true);

    submitBtn.addEventListener('click', function() {
      submitBtn.disabled = true;
      submitBtn.classList.add('btn--loading');
      sendToMailchimp(submitShopify);
    });

    // Closing the popup without choosing still subscribes, as the footer did before.
    document.addEventListener('modalClose.' + modalEl.id, submitShopify);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
